export const DOT_MARKER_ICON_SIZE = 16;
export const DOT_MARKER_ANCHOR = DOT_MARKER_ICON_SIZE / 2;
